export const TIMED_SURVEYS = {
  'wonderlic_a': 12,
  'missing_objects': 5,
  'equal_pairs_4': 3,
  'raven': 5,
};